import React, { useEffect, useState } from "react";
import SocialShare from "./SocialShare";
import { Row } from "reactstrap";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaYelp, FaLink } from "react-icons/fa";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useSelector } from "react-redux";
import axiosClient from "../../../axios-client";
import { toast } from "react-toastify";

const VendorProfileLinks = ({ handleAction }) => {
  const { viewers, viewCount } = useSelector((state) => state.bwvData);
  const selectedCard = useSelector((state) => state.bwvData.selectedService);
  const [avgReplyTime, setAvgReplyTime] = useState(null);

  const fetchAvgReply = async () => {
    try {
      const response = await axiosClient.get(`message/avgReplyTime`);
      if (response.data.statusCode === 200) {
        setAvgReplyTime(response.data.Data);
      } else {
        toast.error(response.data.msg);
      }
    } catch (error) {
      toast.error("Error fetching average reply time");
    }
  };

  useEffect(() => {
    fetchAvgReply();
  }, []);

  const convertMinutesToHours = (minutes) => {
    const totalMinutes = parseFloat(minutes);
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = Math.round(totalMinutes % 60);
    return `${hours} hours, ${remainingMinutes} minutes`;
  };

  const avgResponseTime =
    avgReplyTime && avgReplyTime[0].avg_response_time_in_minutes;
  const formattedTime = avgResponseTime
    ? convertMinutesToHours(avgResponseTime)
    : "N/A";

  // Check if any website links exist
  const hasWebsiteLinks =
    (selectedCard?.websiteLinkOne && selectedCard.websiteLinkOne !== "") ||
    (selectedCard?.websiteLinkTwo && selectedCard.websiteLinkTwo !== "") ||
    (selectedCard?.websiteLinkThree && selectedCard.websiteLinkThree !== "");

  return (
    <>
      <SocialShare />

      <Row className="mt-3">
        {/* Profile Links (Social Media) */}
        <p>
          <b>Profile Links</b>
        </p>
        <div>
          <ul className="d-inline-flex" style={{ gap: "1rem" }}>
            <li>
              {selectedCard?.facebookUrl && selectedCard.facebookUrl !== "" && (
                <Link
                  to={selectedCard.facebookUrl}
                  style={{ fontSize: "22px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Facebook"
                >
                  <FaFacebook />
                </Link>
              )}
            </li>
            <li>
              {selectedCard?.instagramUrl &&
                selectedCard.instagramUrl !== "" && (
                  <Link
                    to={selectedCard.instagramUrl}
                    style={{ fontSize: "22px" }}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram"
                  >
                    <FaInstagram />
                  </Link>
                )}
            </li>
            <li>
              {selectedCard?.yelpUrl && selectedCard.yelpUrl !== "" && (
                <Link
                  to={selectedCard.yelpUrl}
                  style={{ fontSize: "22px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Yelp"
                >
                  <FaYelp />
                </Link>
              )}
            </li>
          </ul>

          {/* Website Links */}
          {hasWebsiteLinks && (
            <>
              <p className="mt-3">
                <b>Website Links</b>
              </p>
              <ul className="d-inline-flex" style={{ gap: "1rem" }}>
                <li>
                  {selectedCard?.websiteLinkOne &&
                    selectedCard.websiteLinkOne !== "" && (
                      <Link
                        to={selectedCard.websiteLinkOne}
                        style={{ fontSize: "22px" }}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Website Link 1"
                      >
                        <FaLink />
                      </Link>
                    )}
                </li>
                <li>
                  {selectedCard?.websiteLinkTwo &&
                    selectedCard.websiteLinkTwo !== "" && (
                      <Link
                        to={selectedCard.websiteLinkTwo}
                        style={{ fontSize: "22px" }}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Website Link 2"
                      >
                        <FaLink />
                      </Link>
                    )}
                </li>
                <li>
                  {selectedCard?.websiteLinkThree &&
                    selectedCard.websiteLinkThree !== "" && (
                      <Link
                        to={selectedCard.websiteLinkThree}
                        style={{ fontSize: "22px" }}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Website Link 3"
                      >
                        <FaLink />
                      </Link>
                    )}
                </li>
              </ul>
            </>
          )}

          <div className="text-center my-2">
            <ChatBubbleOutlineIcon sx={{ fontSize: 15, marginRight: 1 }} />
            Typically replies within {formattedTime}
            <a
              onClick={() => handleAction("TEXT")}
              className="text-success cursor-pointer ms-1"
            >
              Message Now
            </a>
          </div>
          <p>
            👀 {viewers - 1} other people are looking at this vendor right now
          </p>
          <div className="text-center bg-danger text-white p-1 rounded">
            📈 Vendor page viewed {viewCount / 2} times in the last 24 hours
          </div>
        </div>
      </Row>
    </>
  );
};

export default VendorProfileLinks;
